import api from "api";
import { Medication, MedicationSubstance, UpsertMedicationRequest } from "./types";
import { supportApiBase } from "api/constants";

const root = supportApiBase;

export const medicationsApi = {
  list: async (): Promise<Medication[]> => {
    const res = await api.call("/medications", { root });
    return res.json();
  },

  get: async (id: number): Promise<Medication> => {
    const res = await api.call(`/medications/${id}`, { root });
    return res.json();
  },

  create: async (data: UpsertMedicationRequest): Promise<Medication> => {
    const res = await api.call("/medications", { root, data });
    return res.json();
  },

  update: async (id: number, data: UpsertMedicationRequest): Promise<Medication> => {
    const res = await api.call(`/medications/${id}`, { root, data, method: "PUT" });
    return res.json();
  },

  delete: async (id: number): Promise<void> => {
    await api.call(`/medications/${id}`, { root, method: "DELETE" });
  },

  listSubstances: async (): Promise<MedicationSubstance[]> => {
    const res = await api.call("/medication-substances", { root });
    return res.json();
  },

  presignImageUpload: async (
    contentType: string,
    locale?: string
  ): Promise<{ upload_url: string; upload_fields: Record<string, string>; object_url: string }> => {
    const res = await api.call("/medications/upload/presign", {
      root,
      data: { content_type: contentType, locale },
    });
    return res.json();
  },
};
